import { inject } from '@angular/core'
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http'
import { throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { SnackbarService } from '../components/snakbar/snackbar.service'

const FullDetailsParam = 'full-details'

/**
 * Set on a request whose page shows the reason of a failure itself, so it is not
 * also shown in a snackbar over the top bar.
 */
export const SHOWS_OWN_ERRORS = new HttpContextToken<boolean>(() => false)

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService)

  const fullDetailsParam = new URL(window.location.href).searchParams.get(
    FullDetailsParam,
  )

  const forwardFullDetails =
    fullDetailsParam && !req.urlWithParams.includes(`${FullDetailsParam}=`)
  const requestToSend = forwardFullDetails
    ? req.clone({
        url: `${req.urlWithParams}${req.urlWithParams.includes('?') ? '&' : '?'}${FullDetailsParam}=${encodeURIComponent(fullDetailsParam)}`,
      })
    : req

  return next(requestToSend).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status >= 500 && !req.context.get(SHOWS_OWN_ERRORS)) {
        snackbarService.showError(
          error.error.message ??
            'An internal server error occurred. Please try again later.',
        )
      }
      return throwError(() => error)
    }),
  )
}
